import React, { Component } from 'react';
import { connect } from 'react-redux';

import { withRouter } from 'react-router-dom';

import Page from './page';

class LoadingPage extends Component {
  render(){

    const props = this.props;

    return <Page {...props} loading={true} />
  }
}

export default LoadingPage;



// WEBPACK FOOTER //
// ./src/components/shared/loadingPage.js